const fileCreateBrowserPreview = (file) => {
    if (file.preview == null) {
        Object.assign(file, { preview: URL.createObjectURL(file) })
    }

    return file
}

export default fileCreateBrowserPreview